import { render, staticRenderFns } from "./stage-list.vue?vue&type=template&id=0607238c&scoped=true"
import script from "./stage-list.vue?vue&type=script&lang=js"
export * from "./stage-list.vue?vue&type=script&lang=js"
import style0 from "./stage-list.vue?vue&type=style&index=0&id=0607238c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0607238c",
  null
  
)

export default component.exports